/**
 * The "stage" is ready when nothing covers the page: the intro screen has
 * lifted and no page transition is in progress. Entrance animations wait for
 * it so they play where the visitor can actually see them.
 */

type Listener = () => void

let ready = false
const listeners = new Set<Listener>()

export const isStageReady = (): boolean => ready

export const holdStage = (): void => {
    ready = false
}

export const releaseStage = (): void => {
    ready = true
    const pending = Array.from(listeners)
    listeners.clear()
    pending.forEach((listener) => listener())
}

export const onStageReady = (listener: Listener): (() => void) => {
    if (ready) {
        listener()
        return () => undefined
    }

    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}
